<template>
  <ValidationObserver
    ref="searchEanForm"
    v-slot="{ passes }"
  >
    <v-form
      rel="searchEanForm"
      class="px-1"
      @submit.prevent="passes(searchByEAN)"
    >
      <v-row>
        <v-col
          :cols="detailSearch ? '12' : '8'"
          v-if="errorMessage"
        >
          <div :class="!detailSearch ? 'px-9' : false">
            <v-alert type="error">
              {{ errorMessage }}
            </v-alert>
          </div>
        </v-col>

        <v-col
          cols="12"
          class="pb-0"
        >
          <span :class="detailSearch ? '' : 'ml-8'">
            {{ label }}
          </span>
        </v-col>

        <v-col
          :cols="detailSearch ? '12' : '6'"
          class="pb-0"
          ref="searchEan"
        >
          <VTextFieldWithValidation
            :class="detailSearch ? 'detail-searcn-ean' : false"
            rules="required|ean"
            v-model="filters.ean"
            v-mask="'##################'"
            label="Hledání dle EANu"
            outlined
            dense
            :prepend-icon="detailSearch ? '' : (filters.ean ? 'mdi-close' : 'mdi-none')"
            @click:prepend.prevent="clear"
            :append-icon="detailSearch ? (filters.ean ? 'mdi-close' : 'mdi-none') : ''"
            @click:append.prevent="clear"
            :autofocus="!detailSearch"
            mode="passive"
          />
        </v-col>

        <v-col :class="{
          'text-center': detailSearch === true,
          'pb-0': true,
        }">
          <v-btn
            :block="detailSearch"
            depressed
            type="submit"
            color="primary"
            height="40px"
            min-width="125px"
            :loading="searchEanLoading"
          >
            Vyhledat
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SearchEAN',
  props: {
    label: {
      type: String,
      default: 'Zadejte odběrné místo',
      required: false,
    },
    detailSearch: {
      type: Boolean,
      default: false,
      required: false,
    },
    eanErrorMessage: {
      type: String,
      default: null,
      required: false,
    },
    searchEanLoading: {
      type: Boolean,
      default: false,
      required: false,
    },
    routeType: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      filters: {
        ean: null,
      },
      errorMessage: null,
    };
  },
  methods: {
    ...mapActions({
      getInstallation: 'installations/getInstallation',
    }),
    clear() {
      this.filters.ean = null;
      this.$refs.searchEan.querySelector('input').focus();
    },
    searchByEAN() {
      const prefix = this.routeType || this.$route.name.split('.')[0];
      const getInstallationParams = {
        ean: this.filters.ean,
      };
      if (prefix === 'requestNN' || prefix === 'requestVN') {
        getInstallationParams.checkAgreementExistence = true;
      }
      this.errorMessage = null;
      this.$emit('installationLoading', true);
      if (this.detailSearch) {
        this.$emit('searchInstallation', this.filters.ean);
      } else {
        this.getInstallation(getInstallationParams)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.allowedInstallationAction.name === 'NONE_MANUFACTURING_INSTALLATION'
                || response.data.allowedInstallationAction.name === 'NONE_DISTRIBUTION_ONLY_INSTALLATION') {
                this.errorMessage = response.data.allowedInstallationAction.localizedText;
              } else if (response.data.voltageLevel === 'NN' && prefix === 'changeOfReservedCapacity') {
                this.errorMessage = 'Toto odběrné místo má typ NN. Nelze měnit rezervovanou kapacitu.';
              } else if (response.data.voltageLevel === 'NN' && prefix === 'changeOfReservedPower') {
                this.errorMessage = 'Toto odběrné místo má typ NN. Nelze měnit rezervovaný příkon.';
              } else if (response.data.voltageLevel === 'NN' && prefix === 'trialOperation') {
                this.errorMessage = 'Toto odběrné místo má typ NN. Nelze požádat o zkušební provoz.';
              } else if (response.data.voltageLevel === 'NN' && prefix === 'billingException') {
                this.errorMessage = 'Toto odběrné místo má typ NN. Nelze požádat o výjimku z fakturace.';
              } else if (response.data.voltageLevel === 'VN' && prefix === 'reportReading') {
                this.errorMessage = 'Toto odběrné místo má typ VN. Nelze nahlásit odečet.';
              } else if (response.data.voltageLevel === 'VN' && prefix === 'requestNN') {
                this.errorMessage = 'Toto odběrné místo má typ VN. Nelze podat "žádost NN".';
              } else if (response.data.voltageLevel === 'NN' && prefix === 'requestVN') {
                this.errorMessage = 'Toto odběrné místo má typ NN. Nelze podat "žádost VN".';
              } else if (response.data.voltageLevel === 'NN' && prefix === 'requestNN' && response.data.activeAgreementRequest === true) {
                this.errorMessage = 'Pro zadaný EAN již evidujeme aktivní žádost.';
              } else {
                this.$router.push({
                  name: `${prefix}.detail`,
                  params: {
                    ean: response.data.ean,
                    data: response.data,
                  },
                });
              }
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 404) {
              this.errorMessage = 'Zadaný EAN nebyl nalezen';
            }
          }).finally(() => {
            this.$emit('installationLoading', false);
          });
      }
    },
  },
  watch: {
    eanErrorMessage: {
      handler() {
        this.errorMessage = this.eanErrorMessage;
      },
    },
    $route: {
      handler() {
        if (this.detailSearch) {
          this.filters.ean = null;
        }
      },
    },
  },
  created() {
    if (this.$route.params.ean && !this.detailSearch) {
      this.errorMessage = this.$route.params.eanErrorMessage
        ? this.$route.params.eanErrorMessage
        : null;
      this.filters.ean = this.$route.params.ean;
    }
  },
};
</script>

<style lang="scss">
  .detail-searcn-ean .v-icon.v-icon {
    font-size: 12px;
  }

  .detail-searcn-ean .v-input__icon {
    min-width: 12px;
    height: 12px;
    width: 12px;
    margin-top: 7px;
  }

  .detail-searcn-ean .v-input__slot {
    padding-right: 5px !important;
  }
</style>
